var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-header"},[_c('div',{staticClass:"category-header-cnt"},[_c('div',{staticClass:"resources"},[_vm._v("Ressources")]),_c('div',{staticClass:"category-title"},[_vm._v(" "+_vm._s(_vm.category.name)+" ")]),_c('div',{staticClass:"category-description"},[_vm._v(_vm._s(_vm.category.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }